import React from "react";
import { SelectOrganisation } from "../components/org_selection_popup";
import { compose } from "modules/core";
import { withApollo } from '@apollo/client/react/hoc';
import { withSetDefaultOrganisation, withUpdateDefaultOrganisation } from "./orgSelectOperations";


const orgSelectionPopupContainer = (props) => {
  const { setDefaultOrganization, updateDefaultOrganization } = props;
  return (
    <SelectOrganisation setDefaultOrganization={setDefaultOrganization} updateDefaultOrganization={updateDefaultOrganization}{...props} />
  );
}

export default compose(withApollo, withSetDefaultOrganisation, withUpdateDefaultOrganisation)(orgSelectionPopupContainer);